export function deleteOffice(data) {
    let { deleteOfficeRequest, deleteOfficeError, deleteOfficeResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'delete_office',
        this.createBundle('delete_office', { office: data }, this.POST, deleteOfficeRequest, deleteOfficeResult, deleteOfficeError)
    )
}
